// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState } from 'vuex';
import loading from '../../../../share/components/vue/ProcessingIcon';
import logWrapper from '../../../../share/logWrapper';
import eventLogUtil from '../../../../share/util/eventLogUtil';
import util from '../../../../share/util/utils';

export default {

  data() {
    return {
      processing: false,
      turnIgOnChecked: false,
      modelUpdateProcessing: true,

      // 各種ダイアログのバインド値
      modalconfirmtostartregRemoteEngineStartCUType2: false,
      modalwarningkeynotfoundregRemoteEngineStartCUType2: false,
      modalconfirmtogetignitiononregRemoteEngineStartCUType2: false,
      modalconfirmtogetignitiononretryregRemoteEngineStartCUType2: false,
      modalprocessisgoingonregRemoteEngineStartCUType2: false,
      modalsuccessregRemoteEngineStartCUType2: false,
      modalconfirmtogetignitionoffregRemoteEngineStartCUType2: false,
      modalerrfailedregRemoteEngineStartCUType2: false,
      nextModalId: null
    };
  },

  props: {
    onClickOkButtonRegRemoteEngineStartCUType2: Function,
    backEventOnButtonClick: Function,
    onClickRetryOrOkButtonCallIGONAPIRegRemoteEngineStartCuType2: Function,
    imbStatusInfo: Object,
    errorOkButtonClick: Function,
    onSetEndOfProcessingFlag: Function,
    isCausesAndActionDialog: Function,
    changeProcessingStatus: Function,
    modalShowInfo: {
      type: Object,
      require: false,
      default: () => ({ id: "", isShow: false }),
    },
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      vehicle: state => state.vehicle,
      netAppId: state => state.netAppConnector.pairingAppId
    }),
  },

  watch: {
    processing: function (value) {
      this.changeProcessingStatus(value);
    },

    modalShowInfo: {
      handler(value) {
        if (value) {
          const id = value.id.replace(/-/g, "");
          if (util.hasPropertyCheck(this, id)) {
            this[id] = value.isShow;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    igOnOkOrRetryButtonClick: async function (id) {
      await this.onClickRetryOrOkButtonCallIGONAPIRegRemoteEngineStartCuType2(id);
      this.turnIgOnChecked = false;
    },
    successOkButtonClick: function () {
      this.dialogCloseProcess();
      // nextModalId：次のダイアログを表示する際に使用
      this.nextModalId = 'modal-confirm-to-get-ignition-off-regRemoteEngineStartCUType2';
    },
    igOffOkButtonClick: function () {
      this.dialogCloseProcess();
      this.turnIgOnChecked = false;
      this.determineEndOfProcessingFlag();
    },
    igOnCancelButtonClick: async function () {
      this.processing = true;
      await this.backEventOnButtonClick();
      eventLogUtil.updateImbEventLogCanceled(this.netAppId);
      this.processing = false;
      this.turnIgOnChecked = false;
      this.determineEndOfProcessingFlag();
    },
    backEventButtonClick: async function () {
      this.processing = true;
      await this.backEventOnButtonClick();
      this.processing = false;
      this.determineEndOfProcessingFlag();
    },
    cancelButtonClick: function () {
      this.dialogCloseProcess();
      this.determineEndOfProcessingFlag();
    },
    determineEndOfProcessingFlag: function () {
      if (this.vehicle.vehicleInfo === null) {
        logWrapper.log('vehicle information is ', this.vehicle.vehicleInfo);
        this.onSetEndOfProcessingFlag();
      }
    },
    modalShowWEvent: function (mode) {
      const info = { id: this.modalShowInfo.id, isShow: false, nextModal: this.modalShowInfo.nextModal };
      if (mode === "show") {
        info.isShow = true;
      } else {
        // 次のダイアログが設定されていた場合のみ
        if (this.nextModalId) {
          info.nextModal = { id: this.nextModalId, msg: "" };
          this.nextModalId = null;
        }
      }
      this.$emit("modalDisplayStatus", info);
    },

    dialogCloseProcess: function () {
      const id = this.modalShowInfo.id.replace(/-/g, "");
      if (util.hasPropertyCheck(this, id)) {
        this[id] = false;
      }
    }
  },

  created() { },

};